import React from 'react';
import './styles/index.css';
import AppRouter from './routes';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { FavoritesProvider } from './contexts/FavoritesContext';
import { GlobalDataProvider } from './contexts/GlobalDataContext';


const App: React.FC = () => {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <FavoritesProvider>
          <GlobalDataProvider>
            <AppRouter />
          </GlobalDataProvider>
        </FavoritesProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
